var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1H3.5C3.10218 1 2.72064 1.1475 2.43934 1.41005C2.15804 1.6726 2 2.0287 2 2.4V13.6C2 13.9713 2.15804 14.3274 2.43934 14.5899C2.72064 14.8525 3.10218 15 3.5 15H12.5C12.8978 15 13.2794 14.8525 13.5607 14.5899C13.842 14.3274 14 13.9713 14 13.6V5.2M9.5 1L14 5.2M9.5 1L9.5 5.2H14M11 8.7H5M11 11.5H5M6.5 5.9H5",
    stroke: "#105E96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.2e2c049f7312f98b1171cde2d685896c.svg";
export { ForwardRef as ReactComponent };